/**
 * Icon Card Block
 *
 * All functionality related to the Icon Card block.
 */

import { trackCtaClick } from '../analytics';

const IconCard = (function($) {

  // Selectors
  const _s = {
    container: '.wp-block-indp-icon-card',
    title: '.wp-block-indp-icon-card__title'
  };

  // Initialize
  const _init = function() {
    if ($(_s.container).length === 0) {
      return;
    }

    _bindEvents();
  };

  // Bind Events
  const _bindEvents = function() {
    // Track icon card clicks
    $(document).on('click', _s.container, function(e) {
      const $card = $(this);
      const linkUrl = $card.attr('href');
      const linkText = $card.find(_s.title).text().trim();
      
      if (linkUrl && linkText) {
        trackCtaClick(linkText, linkUrl);
      }
    });
  };

  // Public API
  return {
    container: _s.container,
    init: _init
  };

})(jQuery);

export default IconCard;
